var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.dataTableLoading && _vm.dateRange <= 7 && _vm.dateRange >= 0)?_c('v-row',[_c('v-col',{attrs:{"align":"center"}},[_c('v-progress-circular',{attrs:{"indeterminate":"","color":_vm.color,"size":_vm.size,"width":_vm.width}})],1)],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }